// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-container {
  display: flex;
  flex-direction: row-reverse;
  gap: 10px;
}
@media screen and (max-width: 690px) {
  .btn-container {
    flex-direction: column;
  }
}
.btn-container button {
  min-width: 180px;
}

form {
  width: 100%;
}
form .form-control {
  font-size: 14px;
}

.form-row {
  display: flex;
  align-items: center;
}
.form-row.price-phase-name {
  min-width: 158px;
}
.form-row .row-name-container {
  font-size: 110%;
  margin-left: 15px;
  margin-bottom: -5px;
  margin-top: 20px;
}
.form-row .input-container.not-loaded {
  opacity: 0.6;
  pointer-events: none;
}

.event-name {
  position: relative;
  top: 2px;
  font-weight: bold;
}

.label-container,
.field-container {
  padding: 10px;
}

.label-container {
  flex: 1;
  max-width: 200px;
  text-align: right;
  font-size: 14px;
  white-space: nowrap;
}
.label-container .info-icon {
  margin-left: 4px;
  font-size: 0.9em;
  cursor: help;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  opacity: 0.8;
}

.field-container {
  flex: 3;
  max-width: 400px;
  font-size: 14px;
  position: relative;
}
@media screen and (max-width: 650px) {
  .field-container {
    max-width: 100%;
  }
}
.field-container.horizontal-centered {
  display: flex;
  align-items: flex-end;
}
.field-container.hover-pointer *:hover {
  cursor: pointer;
}
.field-container.checkbox-field {
  display: flex;
  align-items: left;
}
.field-container.checkbox-field input {
  width: 15px;
  height: 15px;
}
.field-container.selected-company-row {
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  align-items: center;
}
.field-container.selected-company-row .thumbnail-img {
  width: 60px;
}
.field-container.selected-company-row .icon-close {
  width: 18px;
  height: 18px;
  position: relative;
  top: -2px;
}
.field-container.selected-company-row .icon-close:hover {
  cursor: pointer;
}
.field-container.selected-company-row .company-name span {
  display: block;
}
.field-container .placeholder-select {
  width: 100%;
  height: 34px;
  top: -0.5px;
  position: relative;
  border-radius: 4px;
  border: 1px solid #ccc;
  pointer-events: none;
  opacity: 0.5;
  caret-color: transparent;
}
.field-container .file-input-error {
  font-weight: 700;
  font-size: 12px;
  margin-top: 3px;
  color: red;
  position: absolute;
  width: calc(100% + 8px);
  left: -4px;
  text-align: center;
}
.field-container .allowed-file-types {
  font-size: 12px;
  font-style: italic;
  margin-top: 10px;
}
.field-container .dropdown-menu {
  margin-top: 0;
  margin-left: 10px;
  max-height: 300px;
  overflow-y: auto;
  width: calc(100% - 20px);
}
.field-container .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.field-container .dropdown-menu .dropdown-item img {
  width: 50px;
}

.top-fields {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0 40px;
}
@media screen and (min-width: 650px) and (max-width: 860px) {
  .top-fields {
    margin-top: 50px;
  }
}
.top-fields .form-row.events-cont {
  flex-basis: 48%;
}
.top-fields .form-row.data-cont {
  flex-basis: 42%;
}
@media screen and (max-width: 990px) {
  .top-fields .form-row {
    flex-basis: 100% !important;
  }
}
@media screen and (max-width: 650px) {
  .top-fields .form-row .label-container {
    max-width: 135px;
  }
}

.products-title {
  font-size: 15px;
  border-bottom: 1px solid rgb(229, 229, 229);
  padding-bottom: 10px;
  margin: 10px 0 0;
  padding-left: 10px;
}

.products-main-container {
  overflow: visible;
}
.products-main-container.scroll {
  overflow: visible;
}
.products-main-container.existing-products {
  max-height: 300px !important;
}
.products-main-container .for-main {
  display: flex;
  flex-direction: row;
  gap: 0 10px;
  position: relative;
  padding-right: 30px;
  border-bottom: 1px solid rgb(229, 229, 229);
  padding: 10px 0;
  padding-right: 30px;
  min-width: 1000px;
}
@media screen and (max-width: 1350px) {
  .products-main-container .for-main {
    flex-wrap: wrap;
    min-width: inherit;
  }
}
@media screen and (min-width: 1450px) {
  .products-main-container .for-main {
    max-height: 120px;
  }
}
.products-main-container .for-main.error {
  padding-bottom: 20px;
  max-height: 150px;
}
.products-main-container .for-main:last-child {
  border-bottom: none;
}
.products-main-container .for-main .form-row {
  width: auto;
  display: flex;
  align-items: flex-start;
  width: 275px;
  flex-direction: column;
  margin: 0;
  flex-wrap: nowrap;
}
@media screen and (max-width: 950px) {
  .products-main-container .for-main .form-row {
    width: calc(50% - 5px);
  }
}
@media screen and (max-width: 650px) {
  .products-main-container .for-main .form-row {
    width: 100%;
  }
}
.products-main-container .for-main .form-row.error .label-container {
  color: red;
}
.products-main-container .for-main .form-row.error .field-container input {
  border: 1px solid red;
  color: red;
}
.products-main-container .for-main .form-row.small {
  max-width: 80px;
}
.products-main-container .for-main .form-row.scan-results {
  max-width: 130px;
  margin-right: 20px;
}
.products-main-container .for-main .form-row.sealed .label-container {
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
}
.products-main-container .for-main .form-row.sealed .field-container {
  justify-content: center;
}
.products-main-container .for-main .form-row.sealed .checkbox-field {
  align-items: center;
}
.products-main-container .for-main .form-row .label-container {
  padding-bottom: 0;
  width: 100%;
  text-align: left;
  min-height: 30px;
}
.products-main-container .for-main .form-row .label-container.no-wrap {
  white-space: nowrap;
}
.products-main-container .for-main .form-row .field-container {
  padding: 5px 0;
  width: 100%;
}

.remove-btn-cont {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: auto !important;
  min-width: 0;
  padding: 0;
  z-index: 1;
}
.remove-btn-cont .icon-close {
  display: block !important;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: #999;
}
.remove-btn-cont .icon-close:hover {
  color: #333;
}

.button-row {
  padding: 10px 20px 10px 0;
  display: flex;
  flex-direction: row-reverse;
  border-top: 1px solid rgb(229, 229, 229);
}
.button-row .add-btn {
  cursor: pointer;
  font-size: 15px;
}
.button-row .add-btn:hover {
  opacity: 0.8;
}

.show-existing-row {
  display: flex;
  font-size: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
  flex-wrap: nowrap;
}
.show-existing-row .show-hide-ex-prods {
  cursor: pointer;
  font-weight: 500;
  margin: 10px 0;
}
.show-existing-row .exising-products-cont {
  display: none;
  width: 100%;
  max-width: 700px;
  overflow-y: auto;
  overflow-x: hidden;
}
@media screen and (max-width: 650px) {
  .show-existing-row .exising-products-cont {
    overflow-x: scroll;
  }
}
.show-existing-row .exising-products-cont.show-prods {
  display: block;
}
.show-existing-row .exising-products-cont .exising-products-row {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 700px;
  margin: 3px 0;
  gap: 0 10px;
  min-width: 400px;
}
.show-existing-row .exising-products-cont .ex-title {
  width: 30%;
  max-width: 200px;
}
.show-existing-row .exising-products-cont .ex-subtype {
  width: 30%;
  max-width: 200px;
}
.show-existing-row .exising-products-cont .ex-evdays {
  width: 15%;
  max-width: 100px;
}
.show-existing-row .exising-products-cont .ex-amount {
  width: 15%;
  max-width: 100px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
